document.addEventListener( 'DOMContentLoaded', () => {
    const blocks = document.querySelectorAll( '.section-testimonials__wrap' )
    if ( !blocks.length ) return

    let flickityInstances = [];
    
    const initCarousels = () => {
        destroyCarousels();
        
        if (window.innerWidth > 1024) return

        blocks.forEach( ( block ) => {
            const items = block.querySelectorAll( '.testimonial-item' )
            if ( !items.length ) return

            const holder = block.querySelector( '.section-testimonials__grid' )
            const prev = block.querySelector( '.flickity__arr--prev' )
            const next = block.querySelector( '.flickity__arr--next' )
            const flickity = new Flickity( holder, {
                prevNextButtons: false,
                cellAlign: 'left',
                groupCells: false,
                imagesLoaded: true,
                pageDots: false,
                percentPosition: true,
                autoPlay: false,
                pauseAutoPlayOnHover: false,
                adaptiveHeight: false,
                cellSelector: '.section-testimonials__wrap .testimonial-item',
                selectedAttraction: 0.05,
                wrapAround: false,
                friction: 0.5,
                draggable: true,
                watchCSS: true,
                contain: true
            } );

            const updateNavButtons = () => {
                if (flickity.selectedIndex === 0) {
                    prev.classList.add('disabled');
                } else {
                    prev.classList.remove('disabled');
                }
                
                if (flickity.selectedIndex === flickity.slides.length - 1) {
                    next.classList.add('disabled');
                } else {
                    next.classList.remove('disabled');
                }
            };

            updateNavButtons();
            flickity.on('change', updateNavButtons);

            prev.addEventListener('click', function() {
                flickity.previous();
            });
            next.addEventListener('click', function() {
                flickity.next();
            });
            
            flickityInstances.push(flickity);
        });
    };
    
    const destroyCarousels = () => {
        flickityInstances.forEach(instance => {
            if (instance && typeof instance.destroy === 'function') {
                instance.destroy();
            }
        });
        flickityInstances = [];
    };
    
    // Initialize on load
    initCarousels();
    
    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            initCarousels();
        }, 250);
    });
} )